import cx from "classnames"

const PowerToggle = ({
  isActive = false,
  canEnable = false,
  disable,
}: {
  isActive: boolean
  canEnable?: boolean
  disable: () => void
}) => {
  return (
    <button
      className={cx(
        "ml-3 flex h-3.5 w-3.5 items-center justify-center rounded-full border",
        isActive
          ? "animate-bounce-scale border-[#5A7B5B] bg-[#4B614C] hover:border-silver"
          : "border-earth bg-mine-shaft transition-colors hover:border-silver disabled:border-earth disabled:bg-transparent disabled:opacity-50"
      )}
      disabled={!isActive && !canEnable}
      onClick={() => disable()}
    >
      <div
        className={cx(
          "h-1.75 w-1.75 rounded-full bg-gradient-to-b from-[#AECDA4] to-[#5F8E62] transition-transform duration-100",
          isActive ? "scale-100" : "scale-0"
        )}
      ></div>
    </button>
  )
}

export default PowerToggle
